// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__254zz","dragIcon":"SortableItem_dragIcon__1z07e","disabled":"SortableItem_disabled__3cpXg"};